import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import CSVGuideES from "@/pages/CSVGuideES";

export const Route = createFileRoute("/es/guia-completa-validacion-sistemas-informatizados")({
  head: () => buildRouteHead("/es/guia-completa-validacion-sistemas-informatizados"),
  component: CSVGuideES,
});

